import { render, staticRenderFns } from "./AuctionBids.vue?vue&type=template&id=2ad60dae&"
import script from "./AuctionBids.vue?vue&type=script&lang=js&"
export * from "./AuctionBids.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports